// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"8f3bf345","186":"7a5366ab","459":"54309a64"}[chunkId] + ".chunk.js";
};